<script lang="ts">
  import * as _ from "lodash";
  import { Text } from "@getprovi/craft-svelte";
  import FormatMoney from "@shared/svelte/Components/FormatMoney.svelte";
  import type { CartProduct } from "@shared/types/ProductLine";
  import type { DistributorCart } from "@shared/types/Distributor";
  import type { WarehouseSummaryType } from "@shared/types/Order";

  import {
    OHLQ_DISTRIBUTOR_ID,
    VT_802_SPIRITS_DISTRIBUTOR_ID,
  } from "@shared/services/retailer_user_authentication/constants";

  export let total: number;
  export let subtotal: number;
  export let taxTotal: number;
  export let products: CartProduct[];
  export let orderProducts: CartProduct[];
  export let distributor: DistributorCart;
  export let isExcludedProduct: (
    product: CartProduct,
    orderDetail: WarehouseSummaryType,
  ) => boolean;
  export let locationOrderDetail: WarehouseSummaryType;

  let discountedProducts: CartProduct[] = [];
  let totalSavings = 0;
  let totalDiscounts = 0;

  if (!products && orderProducts) {
    products = orderProducts;
  }

  $: {
    total = total;
    subtotal = subtotal;
    taxTotal = taxTotal;
    products = products;
    orderProducts = orderProducts;
    discountedProducts = products.filter(
      product => !isExcludedProduct(product, locationOrderDetail),
    );
    totalDiscounts = discountedProducts.reduce((acc, product) => {
      return acc + ((product?.discount_amount ?? 0) > 0 ? 1 : 0);
    }, 0);
    distributor = distributor;
    totalSavings = discountedProducts.reduce(
      (sum: number, cartProduct: CartProduct) => sum + cartProduct.discount_amount,
      0,
    );
  }

  const taxLabel = () => {
    if (distributor.id === OHLQ_DISTRIBUTOR_ID) {
      return "Cuyahoga County Gallonage Tax";
    } else if (distributor.id === VT_802_SPIRITS_DISTRIBUTOR_ID) {
      return "Bottle Deposit Total";
    } else {
      return "Tax";
    }
  };
</script>

<section class="craft fizz-flex-row-0-responsive fizz-flex-vertical fizz-full-width">
  <div data-testid="est-total-section" class="fizz-full-width">
    <div class="fizz-flex-row fizz-space-between">
      <Text color="neutral" size="sm">Items subtotal</Text>
      <Text color="neutral" size="sm">
        <FormatMoney input={subtotal} />
      </Text>
    </div>
    {#if totalDiscounts > 0}
      <div class="fizz-flex-row fizz-space-between" data-testid="discount-section">
        <Text color="neutral" size="sm">Discounts ({totalDiscounts} applied)</Text>
        <Text color="neutral" size="sm">
          <FormatMoney input={-1 * totalSavings} />
        </Text>
      </div>
    {/if}
    {#if taxTotal && taxTotal > 0}
      <div class="fizz-flex-row fizz-space-between">
        <Text color="neutral" size="sm">{taxLabel()}</Text>
        <Text color="neutral" size="sm">
          <FormatMoney input={taxTotal} />
        </Text>
      </div>
    {/if}
  </div>
</section>
